import { Pipe, PipeTransform } from '@angular/core';
import {CompetitorStageDetail, FINISH_CONTROL_POINT_TYPE, MeasurementPrecisionTypes} from "@model";
import {resultTime} from "@utility";

@Pipe({
    name: 'finishAndLastCpDiff',
    standalone: false
})
export class FinishAndLastCpDiffPipe implements PipeTransform {

  transform(SGS?: { [key: string]: CompetitorStageDetail }, measurementPrecisionType?: MeasurementPrecisionTypes | undefined): string {
    if (SGS === undefined || SGS === null) {
      return '-';
    }
    const items = Object.values(SGS);
    const sgsFinishItem = items.find((item) => item.tp === FINISH_CONTROL_POINT_TYPE);
    return resultTime(sgsFinishItem?.nt_tm, measurementPrecisionType) || '-';
  }
}
